// extracted by mini-css-extract-plugin
export default {"image-box":"Memoji_image-box__r0shN","blob":"Memoji_blob__hwvWT","image":"Memoji_image__UCcOE","slide-in-right":"Memoji_slide-in-right__WxXD9"};